import React from 'react';
import { ThemeProvider } from 'fronton-react';
import { RecoilRoot } from 'recoil';

import { MainPage } from 'pages/main';
import { TData } from './context';
import { Fallback } from '../../../pages/fallback/fallback';
import { ErrorBoundary } from '../error-boundary';

export type RootProps = TData;
export type RootState = TData;

export const Root: React.FC<RootProps> = data => (
  <ThemeProvider>
    <ErrorBoundary fallback={<Fallback />}>
      <RecoilRoot>
        <MainPage data={data} />
      </RecoilRoot>
    </ErrorBoundary>
  </ThemeProvider>
);
